import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var tabsStyle = function tabsStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    primary6 = _getThemeData.primary6;
  return css([".ant-tabs.ant-tabs{.ant-tabs-ink-bar{background-color:", ";}.ant-tabs-nav{.ant-tabs-tab{&:hover{color:", ";i{color:", ";}}}.ant-tabs-tab-active.ant-tabs-tab-active.ant-tabs-tab-active{color:", ";i,.anticon-close{color:", ";}}}}"], primary6, primary6, primary6, primary6, primary6);
};
export default tabsStyle;